import React, { useEffect, useState } from 'react'
import ModalCustom from '../../../../modal-custom'
import { Button, Col, Form, FormControl } from 'react-bootstrap'
import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import LabelCustomSmall from '../../../../label-custom-small'
import Autocomplete from '../../../../custom/autocomplete'
import {
  createIncomeLoanHomeAccountAPI,
  deleteIncomeLoanHomeAccountAPI,
  updateIncomeLoanHomeAccountAPI
} from '../../../../../services/income/loan-home'
import SwalCustom from '../../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../../Constants'
import Error_false from '../../../../error/error-false'

export default function ModalUpdateLoan({
  optionBanks,
  open,
  onCancel,
  fnGetData,
  data,
  param
}) {
  const schema = yup
    .object({
      loanAcc: yup.string().required('โปรดระบุข้อมูล'),
      bank: yup.object().required('โปรดระบุข้อมูล')
    })
    .required()
  const {
    reset,
    control,
    setValue,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  useEffect(() => {
    if (data) {
      setValue('loanAcc', data.loanAcc ?? '')

      data.bank &&
        setValue('bank', {
          label: data.bank,
          value: data.bankId
        })

      setValue('active', data.active === 1)
    }
  }, [data, setValue])

  const [isSubmit, setIsSubmit] = useState(false)

  const onSubmit = (d) => {
    const body = {
      ...param,
      bankId: d.bank.value,
      loanAcc: d.loanAcc
    }
    if (data) {
      sendAPI(
        updateIncomeLoanHomeAccountAPI({
          loanAccId: data.loanAccId,
          active: d.active ? 1 : 2,
          ...body
        })
      )
    } else {
      sendAPI(createIncomeLoanHomeAccountAPI({ ...body }))
    }
  }

  const fnDelete = () => {
    SwalCustom({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'error',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        let body = { ...param, loanAccId: data.loanAccId }
        sendAPI(deleteIncomeLoanHomeAccountAPI(body))
      }
    })
  }

  const sendAPI = async (api) => {
    setIsSubmit(true)
    const resp = await api
    setIsSubmit(false)
    if (!resp) return
    if (resp.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        onCancel()
        fnGetData()
      })
    } else {
      Error_false(resp)
    }
  }

  return (
    <ModalCustom open={open} onCancel={onCancel}>
      <div>
        <h5>{data ? 'แก้ไข' : 'เพิ่ม'}เลขที่บัญชี</h5>
        <Form onSubmit={handleSubmit(onSubmit)} className="row g-3">
          <Col xl={6}>
            <LabelCustomSmall>ธนาคาร</LabelCustomSmall>
            <Controller
              control={control}
              rules={{
                required: true
              }}
              render={({ field: { onChange, value = '' } }) => (
                <Autocomplete
                  options={optionBanks}
                  value={value}
                  onChange={onChange}
                />
              )}
              name="bank"
            />
            {errors.bank && (
              <label className="small text-danger">{errors.bank.message}</label>
            )}
          </Col>
          <Col xl={6}>
            <LabelCustomSmall>เลขที่บัญชี</LabelCustomSmall>
            <Controller
              control={control}
              rules={{
                required: true
              }}
              render={({ field: { onChange, value = '' } }) => (
                <FormControl
                  pattern="^\d+$"
                  maxLength={20}
                  value={value}
                  onChange={onChange}
                />
              )}
              name="loanAcc"
            />
            {errors.loanAcc && (
              <label className="small text-danger">
                {errors.loanAcc.message}
              </label>
            )}
          </Col>
          {data && (
            <Col xl={12}>
              <Controller
                name={'active'}
                control={control}
                render={({ field: { onChange, value = true } }) => (
                  <Form.Group
                    className="mb-3"
                    controlId="formBasicCheckbox"
                    value={value}
                    onChange={onChange}
                  >
                    <Form.Check
                      checked={value}
                      type="checkbox"
                      label="Active"
                    />
                  </Form.Group>
                )}
              />
            </Col>
          )}

          <Col xl={12} className="text-center mt-5">
            <Button className="me-2 px-4" variant="light" onClick={onCancel}>
              Close
            </Button>
            {data && (
              <Button className="me-2 px-4" variant="danger" onClick={fnDelete}>
                Delete
              </Button>
            )}
            <Button disabled={isSubmit} type="submit" className="px-4">
              Submit{isSubmit && 'ting...'}
            </Button>
          </Col>
        </Form>
      </div>
    </ModalCustom>
  )
}
